import React, { useState, useEffect } from 'react';
//import BlockActionSliderItem from '../blocks/BlockActionSliderItem';
import LoyaltyBlockHomeItem from './LoyaltyBlockHomeItem';
import Slider from "react-slick";
import SmartLink from '../../components/SmartLink';
import { useDispatch, useSelector } from "react-redux";
import { getLoyaltySettings, getLoyaltyProducts } from "../../redux/actions/productActions";
import "../../css/Loyalty.css";
import globalVariable from '../../global';
import { useTranslation } from 'react-i18next';
import LoaderMaskSlider from '../other/LoaderMaskSlider';

function SampleArrow(props) {
    return null;
}

const LoyaltyBlockHome = (props) => {

    const dispatch = useDispatch();
    const getUserBanner = useSelector((state) => state.getUserBanner.items);
    const bannerListItems = getUserBanner.filter((x) => x.anPageKey === 251);
    const bannerList = bannerListItems.filter((x) => x.anBannerPosition === 4);

    const loyaltyProductsList = useSelector((state) => state.getLoyaltyProducts);
    const loyaltySettings = useSelector((state) => state.getLoyaltySettings);
    const getUserInfo = useSelector((state) => state.userInfo);
    const { t } = useTranslation('loyalty');

    const [activeShop, setActiveShop] = useState(0);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        dispatch(getLoyaltySettings());
        dispatch(getLoyaltyProducts());
    }, []);

    useEffect(() => {
        if (loyaltyProductsList && loyaltyProductsList.companyLoyalityShop) {
            setLoading(false);
        }
    }, [loyaltyProductsList]);

    const settingsSlider = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 5,
        responsive: [
            { breakpoint: 1921, settings: { slidesToShow: 3, slidesToScroll: 3 } },
            { breakpoint: 1680, settings: { slidesToShow: 2, slidesToScroll: 2 } },
            { breakpoint: 1440, settings: { slidesToShow: 2, slidesToScroll: 2 } },
            { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        ]
    };

    if (!getUserInfo) {
        return null;
    }

    return (
        <>
            {loyaltySettings.anCompanyTarget > 0 && (
                <div className="action-block-special loyalty-slider-content">
                    <div className="action-block-special-content">
                        <div className="action-block-special-banner">
                            <SmartLink to={bannerList[0] && bannerList[0].acBannerLink} isNewTabOpen={bannerList[0] && bannerList[0].isNewTabOpen}>
                                <div className="action-block-special-banner-background-wrapper" style={{ overflow: 'hidden' }}>
                                    <div className="action-block-special-banner-bacground" style={{ background: `url(akcija-baner-2.jpg)`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }}></div>
                                    {bannerList[0] && (<img src={`${globalVariable.imagesPath}/media/${bannerList[0].acBannerImage}`} alt={`${bannerList[0].acSeoDescription}`} title={`${bannerList[0].acSeoTitle}`} />)}
                                </div>
                            </SmartLink>
                        </div>
                        <div className="action-block-special-slider">
                            <SmartLink to="/loyalty-artikli" className='link'>
                                <div className="action-block-special-slider-title-main">
                                    <h2>{t('n')}<span>{t('EWE')}</span>{t('rovatanShop')}</h2>
                                </div>
                            </SmartLink>

                            {loading ? (
                                <div className="loyalty-msg-holder">
                                    <div className="loading-block">
                                        <LoaderMaskSlider />
                                    </div>
                                </div>
                            ) : (
                                loyaltyProductsList && loyaltyProductsList.companyLoyalityShop && loyaltyProductsList.companyLoyalityShop.length > 0 ? (
                                    <div className="action-block-special-slider-main-slider">
                                        <Slider {...settingsSlider}>
                                            {loyaltyProductsList.companyLoyalityShop.map((item2, key2) => {
                                                return (
                                                    item2.loyaltyShopItemList.map((item, key) => (
                                                        <LoyaltyBlockHomeItem
                                                            item={item}
                                                            key={key}
                                                            isMaxWidth={loyaltyProductsList.companyLoyalityShop.length}
                                                            shopIsActive={activeShop}
                                                            getUserInfo={getUserInfo.userInfo.companyAdditionalInfo}
                                                            loyaltySettings={loyaltySettings}
                                                        />
                                                    ))
                                                );
                                            })}
                                        </Slider>
                                    </div>
                                ) : (
                                    <div className="loyalty-msg-holder">
                                        <div className="alert alert-primary" role="alert">
                                            {t('nisuSetovaniArtikli')}
                                        </div>
                                    </div>
                                )
                            )}

                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default LoyaltyBlockHome;